import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'formatfein' })
export class FeinFormatterPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return value;
        }

        const trimedValue = value.trim();

        if (trimedValue.length !== 9) {
            return trimedValue;
        }
        return trimedValue.substring(0, 2) + '-' + trimedValue.substring(2, 9);
    }
}
